import { NullableNumberField } from "./NullableNumberField";
import { PasswordField } from "./PasswordField";
import { SelectField } from "./SelectField";
import { StepperInputField } from "./StepperInputField";
import { TextField } from "./TextField";
import { AutocompleteField } from "./AutocompleteField";
import { CheckboxField } from "./CheckboxField";
import { SwitchField } from "./SwitchField";
import { TextAreaField } from "./TextAreaField";
import { DateField } from "./DateField";
import { CustomField } from "./CustomField";
import { PercentageField } from "./PercentageField";
import { OTPField } from "./OTPField";
import { TagSelectField } from "./TagSelectField";

export const FormFields = {
	NullableNumber: NullableNumberField,
	Percentage: PercentageField,
	OTP: OTPField,
	Password: PasswordField,
	Select: SelectField,
	Stepper: StepperInputField,
	Text: TextField,
	Autocomplete: AutocompleteField,
	Checkbox: CheckboxField,
	Switch: SwitchField,
	TextArea: TextAreaField,
	Date: DateField,
	Custom: CustomField,
	TagSelect: TagSelectField,
};
